import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { devicesAPI } from '../../api/api';

export const fetchDevices = createAsyncThunk('devices/fetchAll', async () => {
  const response = await devicesAPI.getAll();
  return response.data.data;
});

export const fetchDeviceById = createAsyncThunk(
  'devices/fetchById',
  async (id) => {
    const response = await devicesAPI.getById(id);
    return response.data.data;
  },
);

export const fetchDeviceBySerial = createAsyncThunk(
  'devices/fetchBySerial',
  async (serial, { rejectWithValue }) => {
    try {
      const response = await devicesAPI.getBySerial(serial);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchDeviceRepairs = createAsyncThunk(
  'devices/fetchRepairs',
  async (id) => {
    const response = await devicesAPI.getRepairs(id);
    return response.data.data;
  },
);

export const createDevice = createAsyncThunk(
  'devices/create',
  async (data) => {
    const response = await devicesAPI.create(data);
    return response.data.data;
  },
);

export const updateDevice = createAsyncThunk(
  'devices/update',
  async ({ id, data }) => {
    const response = await devicesAPI.update(id, data);
    return response.data.data;
  },
);

export const deleteDevice = createAsyncThunk('devices/delete', async (id) => {
  await devicesAPI.delete(id);
  return id;
});

const devicesSlice = createSlice({
  name: 'devices',
  initialState: {
    items: [],
    currentDevice: null,
    deviceRepairs: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrentDevice: (state) => {
      state.currentDevice = null;
      state.deviceRepairs = [];
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDevices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDevices.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchDevices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchDeviceById.fulfilled, (state, action) => {
        state.currentDevice = action.payload;
      })
      .addCase(fetchDeviceRepairs.fulfilled, (state, action) => {
        state.deviceRepairs = action.payload;
      })
      .addCase(createDevice.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateDevice.fulfilled, (state, action) => {
        const index = state.items.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) state.items[index] = action.payload;
      })
      .addCase(deleteDevice.fulfilled, (state, action) => {
        state.items = state.items.filter((item) => item.id !== action.payload);
      });
  },
});

export const { clearCurrentDevice, clearError } = devicesSlice.actions;
export default devicesSlice.reducer;
